import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_maitred_event.js";
//#region src/bite_log_maitred_event_helper.ts
var bite_log_maitred_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "order-validate-error";
		case 2: return "order-send-to-pos-error";
		case 3: return "order-courier-validate-error";
		case 4: return "order-send-to-loyalty-error";
		case 5: return "order-send-to-i9ns-error";
		case 11: return "order-validated";
		case 12: return "order-validation-skipped";
		case 13: return "order-validation-superseded";
		case 14: return "order-validation-skipped-unchanged";
		case 21: return "order-received";
		case 23: return "order-sent-to-pos";
		case 24: return "order-sent-to-loyalty";
		case 25: return "late-order-received";
		case 26: return "order-sent-to-i9ns";
		case 36: return "screenshot-received";
		case 37: return "device-logs-received";
		case 46: return "order-sending-skipped";
		case 47: return "order-send-to-loyalty-skipped";
		case 48: return "order-voided-on-loyalty";
		case 49: return "order-void-on-loyalty-error";
		case 50: return "order-void-on-loyalty-skipped";
		case 53: return "webhook-received";
		case 59: return "webhook-86d-items-successful";
		case 58: return "webhook-86d-items-failed";
		case 61: return "webhook-menu-update-successful";
		case 60: return "webhook-menu-update-failed";
		case 54: return "transaction-committed";
		case 55: return "transaction-commit-error";
		case 56: return "transaction-refund-issued";
		case 57: return "transaction-refund-error";
		case 62: return "order-validated-on-loyalty";
		case 63: return "order-validation-on-loyalty-skipped";
		case 64: return "order-validation-on-loyalty-error";
		case 65: return "order-validated-on-loyalty";
		case 66: return "order-validation-on-other-error";
		case 67: return "order-validation-on-other-error";
		case 225: return "order-created-on-pos";
		case 226: return "order-created-on-pos-error";
		case 227: return "order-created-on-pos-skipped";
		case 221: return "order-add-to-create-order-queue";
		case 222: return "order-add-to-create-order-queue-error";
		case 223: return "order-get-create-order-queue-error";
		case 105: return "order-created-on-loyalty";
		case 106: return "order-created-on-loyalty-error";
		case 107: return "order-created-on-loyalty-skipped";
		case 224: return "order-wait-time-create-order-queue";
		case 235: return "order-updated-on-pos";
		case 236: return "order-update-on-pos-error";
		case 237: return "order-update-on-pos-skipped";
		case 231: return "order-add-to-update-order-on-pos-queue";
		case 232: return "order-add-to-update-order-on-pos-queue-error";
		case 233: return "order-get-update-order-on-pos-queue-error";
		case 234: return "order-wait-time-update-order-on-pos-queue";
		case 71: return "order-patch-on-qsr";
		case 72: return "order-patch-on-qsr-error";
		case 82: return "order-receipt-email";
		case 81: return "guest-receipt-email-error";
		case 86: return "guest-receipt-sms-sent";
		case 85: return "guest-receipt-sms-error";
		case 2100: return "guest-merge";
		case 91: return "notifier-send-error";
		case 92: return "loyalty-signup-sms-error";
		case 93: return "loyalty-signup-sms";
		case 96: return "loyalty-signup-instant-enroll-error";
		case 97: return "loyalty-signup-instant-enroll";
		case 94: return "notification-add-to-queue";
		case 95: return "notification-add-to-queue-error";
		case 101: return "order-created";
		case 102: return "order-created-error";
		case 103: return "idempotent-order-created";
		case 104: return "idempotent-order-received";
		case 111: return "order-validate-tip";
		case 112: return "order-validate-tip-error";
		case 113: return "order-validate-donation";
		case 114: return "order-validate-donation-error";
		case 121: return "order-updated";
		case 122: return "order-updated-error";
		case 123: return "free-item-promotion-applied";
		case 126: return "order-cloned";
		case 127: return "order-cloned-error";
		case 131: return "order-closed";
		case 132: return "order-closed-error";
		case 133: return "idempotent-order-closed";
		case 151: return "order-cancelled";
		case 152: return "order-cancelled-error";
		case 153: return "idempotent-order-cancelled";
		case 161: return "order-refunded";
		case 162: return "order-cancelled-error";
		case 163: return "idempotent-order-refunded";
		case 171: return "order-abandoned";
		case 172: return "order-abandon-error";
		case 401: return "order-coupon-add";
		case 402: return "order-coupon-add-error";
		case 501: return "order-coupon-remove";
		case 502: return "order-coupon-remove-error";
		case 551: return "order-comp-card-apply";
		case 552: return "order-comp-card-apply-error";
		case 553: return "order-comp-card-remove";
		case 554: return "order-comp-card-remove-error";
		case 561: return "order-sent-to-comp-card";
		case 562: return "order-send-to-comp-card-error";
		case 563: return "order-send-to-comp-card-skipped";
		case 564: return "order-voided-on-comp-card";
		case 565: return "order-void-on-comp-card-error";
		case 566: return "order-void-on-comp-card-skipped";
		case 603: return "order-loyalty-add-unapplied-reward";
		case 604: return "order-loyalty-add-unapplied-reward-error";
		case 601: return "order-loyalty-add-reward";
		case 602: return "order-loyalty-add-reward-error";
		case 701: return "order-loyalty-get-available-rewards";
		case 702: return "order-loyalty-get-available-rewards-error";
		case 703: return "loyalty-get-available-rewards-no-order";
		case 704: return "loyalty-get-available-rewards-no-order-error";
		case 901: return "order-loyalty-auth";
		case 902: return "order-loyalty-auth-error";
		case 911: return "order-loyalty-sign-out";
		case 912: return "order-loyalty-sign-out-error";
		case 801: return "order-loyalty-remove-reward";
		case 802: return "order-loyalty-remove-reward-error";
		case 803: return "order-loyalty-idempotent-remove-reward";
		case 850: return "order-loyalty-redeem-reward-code";
		case 851: return "order-loyalty-redeem-reward-code-error";
		case 201: return "order-add-to-send-order-queue";
		case 202: return "order-add-to-send-order-queue-error";
		case 203: return "order-get-send-order-queue-error";
		case 207: return "order-add-to-validate-order-queue";
		case 208: return "order-add-to-validate-order-queue-error";
		case 209: return "order-get-validate-order-queue-error";
		case 301: return "payment-flash-create";
		case 302: return "payment-flash-create-error";
		case 303: return "payment-flash-create-idempotent";
		case 311: return "payment-kiosk-create";
		case 312: return "payment-kiosk-create-error";
		case 313: return "payment-kiosk-create-idempotent";
		case 353: return "payment-kiosk-api-create";
		case 354: return "payment-kiosk-api-create-error";
		case 367: return "payment-kiosk-pre-read-card-queue";
		case 368: return "payment-kiosk-pre-read-card-queue-error";
		case 369: return "payment-kiosk-pre-read-card";
		case 340: return "payment-kiosk-pre-read-card-error";
		case 355: return "payment-kiosk-api-create-idempotent";
		case 365: return "payment-kiosk-api-recovery";
		case 366: return "payment-kiosk-api-recovery-error";
		case 356: return "payment-kiosk-cancel";
		case 357: return "payment-kiosk-cancel-error";
		case 324: return "payment-stored-value-inquire";
		case 325: return "payment-stored-value-inquire-error";
		case 321: return "payment-stored-value-create";
		case 322: return "payment-stored-value-create-error";
		case 323: return "payment-stored-value-create-idempotent";
		case 326: return "payment-get-stored-value-create-queue-error";
		case 329: return "payment-stored-value-get-tenders";
		case 330: return "payment-stored-value-get-tenders-error";
		case 327: return "payment-stored-value-balance-lookup";
		case 328: return "payment-stored-value-balance-lookup-error";
		case 331: return "payment-refund";
		case 332: return "payment-refund-error";
		case 333: return "payment-refund-idempotent";
		case 334: return "payment-get-refund-queue-error";
		case 335: return "payment-add-to-refund-queue";
		case 336: return "payment-refund-add-to-refund-queue-error";
		case 337: return "payment-get-ecomm-queue-error";
		case 338: return "payment-add-to-ecomm-queue";
		case 339: return "payment-add-to-ecomm-queue-error";
		case 350: return "payment-get-kiosk-api-queue-error";
		case 351: return "payment-add-to-kiosk-api-queue";
		case 352: return "payment-add-to-kiosk-api-queue-error";
		case 359: return "payment-stripe-disbursement-add-to-queue";
		case 360: return "payment-stripe-disbursement-add-to-queue-error";
		case 358: return "payment-stripe-disbursement-error";
		case 362: return "payment-stripe-disbursement-reversal-add-to-queue";
		case 363: return "payment-stripe-disbursement-reversal-add-to-queue-error";
		case 361: return "payment-stripe-disbursement-reversal-error";
		case 1001: return "menu-fetch";
		case 1002: return "menu-fetch-error";
		case 204: return "order-wait-time-send-order-queue";
		case 210: return "order-wait-time-validate-order-queue";
		case 205: return "order-send-attempt-duration";
		case 206: return "order-client-send-duration";
		case 1004: return "menu-sync-duration";
		case 1003: return "menu-sync-wait-time-quicksand-queue";
		case 1005: return "menu-sync-duration-and-wait-time";
		case 1006: return "menu-sync-error";
		case 1100: return "queue-job-completed";
		case 1101: return "queue-job-stalled";
		case 1102: return "queue-job-failure";
		case 1105: return "queue-job-requeued";
		case 1103: return "queue-waiting-count-ok";
		case 1104: return "queue-waiting-count-error";
		case 1200: return "report-send";
		case 1201: return "report-send-error";
		case 1300: return "webhook-send";
		case 1301: return "webhook-send-error";
		case 1400: return "sms-notifier-send";
		case 1401: return "sms-notifier-send-error";
		case 1402: return "sms-notifier-send-error-light";
		case 1500: return "kiosk-payment-terminal-get-status";
		case 1501: return "kiosk-payment-terminal-get-status-error";
		case 1502: return "kiosk-payment-terminal-stopped-during-payment";
		case 1503: return "kiosk-payment-terminal-stopped-during-payment-error";
		case 1504: return "kiosk-payment-terminal-wake-up";
		case 1505: return "kiosk-payment-terminal-wake-up-error";
		case 1506: return "kiosk-payment-terminal-model-check-error";
		case 1600: return "expo-print-auth-error";
		case 364: return "payment-wait-time-kiosk-api-payment-queue";
		case 1700: return "fulfillment-payload-fetch-success";
		case 1701: return "fulfillment-payload-fetch-error";
		case 1702: return "fulfillment-payload-send-attempt-success";
		case 1703: return "fulfillment-payload-send-attempt-error";
		case 381: return "payment-native-response-correction";
		case 382: return "payment-native-response-exception";
		case 385: return "payment-native-refund-requested";
		case 1710: return "order-send-to-fulfillment-error";
		case 1711: return "order-send-to-fulfillment-skipped";
		case 1712: return "order-sent-to-fulfillment";
		case 1801: return "order-send-to-marketing-error";
		case 1802: return "order-send-to-marketing-skipped";
		case 1800: return "order-sent-to-marketing";
		case 1803: return "order-redirected-to-survey";
		case 1804: return "order-redirect-to-survey-error";
		case 950: return "order-fetch-guest-history";
		case 951: return "order-fetch-guest-history-error";
		case 953: return "order-fetch-guest-history-no-guest-found";
		case 954: return "order-fetch-guest-history-loyalty";
		case 955: return "order-fetch-guest-history-loyalty-error";
		case 952: return "order-fetch-guest-history-matching-error";
		case 1900: return "menu-cache-get-menu-components-error";
		case 1910: return "menu-cache-put-menu-components-error";
		case 1911: return "menu-cache-put-menu-timestamp-error";
		case 1912: return "menu-cache-put-menu-last-updated-timestamp-error";
		case 1920: return "menu-cache-assemble-and-store-menu-components-error";
		case 1921: return "menu-cache-assemble-and-store-menu-components";
		case 1930: return "menu-cache-job-build-error";
		case 1931: return "menu-cache-job-assemble-and-store-menu-components-error";
		case 1932: return "menu-cache-job-get-menu-last-updated-timestamp-error";
		case 1933: return "menu-cache-job-cache-outdated-error";
		case 1934: return "menu-cache-job-location-not-found-error";
		case 1935: return "menu-cache-job-location-cannot-use-cache-warning";
		case 1936: return "menu-cache-gzip-compress-duration";
		case 1937: return "menu-cache-gzip-decompress-duration";
		case 2e3: return "webhook-third-party-order-accepted";
		case 2001: return "webhook-third-party-order-rejected";
		case 2010: return "third-party-order-send-error";
		case 2011: return "third-party-order-wait-time-send-order-queue";
		case 2012: return "third-party-order-send-attempt-duration";
		case 2013: return "third-party-order-send-to-fulfillment-error";
		case 2014: return "third-party-order-send-to-fulfillment-skipped";
		case 2015: return "third-party-order-sent-to-fulfillment";
		case 2200: return "validate-integration-credentials-error";
		case 2301: return "kor-alert-subscribed";
		case 2302: return "kor-alert-unsubscribed";
		case 2400: return "offline-mode-order-processed-by-backend-success";
		case 2401: return "offline-mode-order-processed-by-backend-error";
	}
}
//#endregion
export { bite_log_maitred_event_helper_exports, name };

//# sourceMappingURL=bite_log_maitred_event_helper.js.map